import styled from 'styled-components'


export const Container = styled.div`
  position: relative;

  width: 100%;
  height: 100px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const TitleContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  margin-top: 0.1em;
  margin-left: 3em;
`

export const Item = styled.div`
  position: relative;
  width: 100%;
`